module.exports = __webpack_public_path__ + "static/media/06_avatar_female.e325f420.png";